import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scroll", "dot", "slide", "headerCell", "valueCell", "detailsSection", "detailsToggle", "activeName"]
  static values = { activeIndex: { type: Number, default: 0 } }

  connect() {
    this.setHeader(this.activeIndexValue)
    this.setColumn(this.activeIndexValue)
    this.setActiveName(this.activeIndexValue)
    if (!this.hasScrollTarget || this.dotTargets.length === 0 || this.slideTargets.length === 0) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index)
            this.activeIndexValue = idx
            this.setDot(idx)
            this.setHeader(idx)
            this.setColumn(idx)
            this.setActiveName(idx)
          }
        })
      },
      { root: this.scrollTarget, threshold: 0.6 }
    )

    this.slideTargets.forEach((slide) => this.observer.observe(slide))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  jump(event) {
    const index = Number(event.currentTarget.dataset.index)
    this.activeIndexValue = index
    this.setHeader(index)
    this.setColumn(index)
    this.setActiveName(index)
    this.scrollSlideIntoView(index)
  }

  selectColumn(event) {
    const index = Number(event.currentTarget.dataset.index)
    this.activeIndexValue = index
    this.setHeader(index)
    this.setColumn(index)
    this.setActiveName(index)
    this.openDetails()
    this.scrollSlideIntoView(index)
  }

  toggleDetails() {
    if (!this.hasDetailsSectionTarget) return
    const hidden = this.detailsSectionTarget.classList.toggle("hidden")
    if (this.hasDetailsToggleTarget) {
      this.detailsToggleTarget.textContent = hidden ? "More details" : "Hide details"
    }
    if (!hidden) {
      this.scrollSlideIntoView(this.activeIndexValue)
    }
  }

  scrollSlideIntoView(index) {
    if (!this.hasScrollTarget) return
    const slide = this.slideTargets[index]
    if (!slide) return

    const left = slide.offsetLeft - this.scrollTarget.offsetLeft
    this.scrollTarget.scrollTo({ left, behavior: "smooth" })
  }

  openDetails() {
    if (!this.hasDetailsSectionTarget) return
    if (!this.detailsSectionTarget.classList.contains("hidden")) return
    this.detailsSectionTarget.classList.remove("hidden")
    if (this.hasDetailsToggleTarget) this.detailsToggleTarget.textContent = "Hide details"
  }

  setDot(activeIndex) {
    this.dotTargets.forEach((dot, idx) => {
      const inner = dot.querySelector("span")
      if (!inner) return
      inner.classList.toggle("bg-blue-600", idx === activeIndex)
      inner.classList.toggle("bg-gray-300", idx !== activeIndex)
    })
  }

  setHeader(activeIndex) {
  }

  setColumn(activeIndex) {
    if (this.valueCellTargets.length === 0) return
    this.valueCellTargets.forEach((cell) => {
      const idx = Number(cell.dataset.colIndex)
      cell.classList.toggle("bg-blue-50", idx === activeIndex)
    })
  }

  setActiveName(activeIndex) {
    if (!this.hasActiveNameTarget || this.headerCellTargets.length === 0) return
    const name = this.headerCellTargets[activeIndex]?.dataset.name
    if (name) this.activeNameTarget.textContent = name
  }
}
